import { graphql, HttpResponse } from 'msw'
import { type DeletePasskeyOutput, type PasskeysOutput, type UpdatePasskeyNicknameOutput } from '../../models'

export const passkeysMock: PasskeysOutput = {
  results: [
    {
      alias: 1,
      displayName: 'Passkey 1',
      nickName: 'Passkey 1',
      createdTime: '2024-10-16',
      updatedTime: '2024-10-16',
    },
  ],
}

export const updatePasskeyNicknameMock: UpdatePasskeyNicknameOutput = {
  empty: true,
}

export const deletePasskeyMock: DeletePasskeyOutput = {
  empty: true,
}

export const mockGetPasskeysHandler = graphql.query('passkeys', () => {
  return HttpResponse.json({ data: { passkeys: passkeysMock } })
})

export const mockUpdatePasskeyNicknameHandler = graphql.mutation('updatePasskeyNickname', () => {
  return HttpResponse.json({ data: { updatePasskeyNickname: updatePasskeyNicknameMock } })
})

export const mockDeletePasskeyHandler = graphql.mutation('deletePasskey', () => {
  return HttpResponse.json({ data: { deletePasskey: deletePasskeyMock } })
})

export const mockPasskey = [mockGetPasskeysHandler, mockUpdatePasskeyNicknameHandler, mockDeletePasskeyHandler]
